import React from 'react';
import { useController, Control, FieldValues, Path } from 'react-hook-form';

interface Option {
  value: string;
  label: string;
}

interface RHFInputSelectProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  options: Option[];
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export function RHFInputSelect<T extends FieldValues>({
  name, control, label, options, required, disabled, placeholder, className
}: RHFInputSelectProps<T>) {
  const { field, fieldState } = useController({ name, control });

  return (
    <div className={`fv-row mb-5 ${className || ''}`}>
      <label className={`form-label ${required ? 'required' : ''}`}>{label}</label>
      <select
        className={`form-select ${fieldState.error ? 'is-invalid' : ''}`}
        disabled={disabled}
        value={field.value ?? ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        ref={field.ref}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(opt => (
          opt.value === '__separator__'
            ? <option key="__sep__" disabled>───────────</option>
            : <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {fieldState.error && (
        <div className="fv-plugins-message-container invalid-feedback">
          {fieldState.error.message}
        </div>
      )}
    </div>
  );
}
